import { useContext } from "react"
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material"
import { LanguageContext } from "../hooks/LanguageContext";
import { PartnersContext } from "../hooks/PartnersContext";
import { useAuth } from "../hooks/useAuth";

const BackArrowButton = ({ pageTitle }) => {
  const backToDashboard = pageTitle === "unicity_news";
  const backToPartners = pageTitle === "search_results";
  const navigate = useNavigate();
  const { languageDir } = useContext(LanguageContext);
  const { downlineUid } = useContext(PartnersContext);
  const { userInfo } = useAuth();
  // eslint-disable-next-line
  const backToSignedInUser = downlineUid == userInfo.unicityId;
  console.log('backToSignedInUser:', backToSignedInUser)

  const handleBack = () => {
    if (backToDashboard) {
      navigate("/dashboard", { replace: true })
    } else if (backToPartners) {
      if (backToSignedInUser) {
        navigate("/partners", { replace: true })
      } else {
        navigate(`/partners/${downlineUid}`, { replace: true })
      }
    } else {
      navigate(-1);
    }
  }

  return (
    <IconButton
      id="back-arrow"
      data-test-id="back-arrow"
      aria-label="back arrow"
      onClick={handleBack}
      sx={{
        height: "40px",
        width: "40px",
        border: "1px solid rgba(145, 158, 171, 0.1)",
        boxShadow: "0px 1px 3px rgba(145, 158, 171, 0.1)",
        borderRadius: "8px"
      }}
    >
      <img
        src="icons/arrow-left.svg"
        alt="menu-icon"
        style={{ transform: languageDir === "rtl" ? "rotate(180deg)" : "none" }}
      />
    </IconButton>
  )
}

export { BackArrowButton }